import script from "./ProductLotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductLotes.vue?vue&type=script&setup=true&lang=js"

import "./ProductLotes.vue?vue&type=style&index=0&id=1a3b5886&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3b5886"]])

export default __exports__